// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qwnu","rootMobile":"styles_rootMobile__MnH8y"};